import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../redux/auth/authActions';
import { Link, useNavigate } from 'react-router-dom';
import { assets } from '../../assets/assets';

const LoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user }  = useSelector((s) => s.auth);
  const userId    = user?.role_id;

  const [formData, setFormData]       = useState({ identifier: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError]             = useState('');

  const { identifier, password } = formData;

  useEffect(() => {
    if (userId === 3)              navigate('/auth/ExecutorCp');
    else if (userId === 1)         navigate('/auth/AdminCp');
    else if (userId === 5)         navigate('/hr-dashboard');
    else if (userId === 2 || userId === 4) navigate('/dashboard');
    else if (userId === null)      navigate('/');
  }, [userId]);

  const handleChange = (e) => {
    setError('');
    const { name, value } = e.target;
    if (name === 'identifier') {
      setFormData({ ...formData, identifier: value, username: value, email: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!identifier || !password) { setError('Please fill in all fields.'); return; }
    dispatch(login(formData));
  };

  return (
    <div style={s.page} className="login-page">
      <style>{`
        @media (max-width: 900px) {
          .login-page  { grid-template-columns: 1fr !important; }
          .login-left  { display: none !important; }
          .login-right { padding: 32px 5% !important; }
        }
        @media (max-width: 480px) {
          .login-form-card { padding: 28px 22px 24px !important; }
        }
      `}</style>

      {/* Left panel */}
      <div style={s.leftPanel} className="login-left">
        <div style={s.leftInner}>
          <img src={assets.logo_img} alt="UPL" style={s.logo} />
          <h2 style={s.leftHeading}>Welcome back to UPL</h2>
          <p style={s.leftSub}>
            Your journey to becoming an industry-ready developer continues here.
            Sign in to access your dashboard, courses, and progress.
          </p>
          <div style={s.statsRow}>
            {[
              { val: '1k+', label: 'Students Enrolled' },
              { val: '50+', label: 'Expert Courses'    },
              { val: '4.8', label: 'Average Rating'    },
            ].map((st) => (
              <div key={st.label} style={s.statItem}>
                <div style={s.statVal}>{st.val}</div>
                <div style={s.statLabel}>{st.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right panel — form */}
      <div style={s.rightPanel} className="login-right">
        <div style={s.formCard} className="login-form-card">
          {/* Close */}
          <Link to="/" style={s.close}>✕</Link>

          <h1 style={s.formHeading}>Sign in to your account</h1>
          <p style={s.formSub}>
            Don't have an account?{' '}
            <Link to="/registerform" style={s.inlineLink}>Sign up for free</Link>
          </p>

          <form onSubmit={handleSubmit} style={s.form}>
            {/* Email / Username */}
            <div style={s.field}>
              <label style={s.label}>Email or Username</label>
              <div style={s.inputWrap}>
                <svg style={s.inputIcon} viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2">
                  <path d="M19 21v-2a4 4 0 00-4-4H9a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
                <input
                  name="identifier" value={identifier} onChange={handleChange}
                  placeholder="Enter your email or username"
                  style={s.input} autoComplete="username"
                  onFocus={e => e.target.parentNode.style.borderColor = '#2563EB'}
                  onBlur={e  => e.target.parentNode.style.borderColor = '#CBD5E1'}
                />
              </div>
            </div>

            {/* Password */}
            <div style={s.field}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <label style={s.label}>Password</label>
                <Link to="/forgotPassword" style={{ fontSize: 13, color: '#2563EB', textDecoration: 'none', fontWeight: 600 }}>
                  Forgot password?
                </Link>
              </div>
              <div style={s.inputWrap}>
                <svg style={s.inputIcon} viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
                </svg>
                <input
                  name="password" value={password} onChange={handleChange}
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  style={s.input} autoComplete="current-password"
                  onFocus={e => e.target.parentNode.style.borderColor = '#2563EB'}
                  onBlur={e  => e.target.parentNode.style.borderColor = '#CBD5E1'}
                />
                <button type="button" onClick={() => setShowPassword(!showPassword)} style={s.eyeBtn}>
                  {showPassword
                    ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                    : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  }
                </button>
              </div>
            </div>

            {error && (
              <div style={{ background: '#FEF2F2', border: '1px solid #FCA5A5', borderRadius: 8, padding: '10px 14px', color: '#B91C1C', fontSize: 14 }}>
                {error}
              </div>
            )}

            <button type="submit" style={s.btn}
              onMouseEnter={e => e.target.style.background = '#1D4ED8'}
              onMouseLeave={e => e.target.style.background = '#2563EB'}
            >
              SIGN IN
            </button>
          </form>

          <p style={s.terms}>
            By signing in, you agree to our{' '}
            <a href="#" style={s.inlineLink}>Terms of Service</a> &{' '}
            <a href="#" style={s.inlineLink}>Privacy Policy</a>.
          </p>

          <div style={{ borderTop: '1px solid #E2E8F0', margin: '4px 0 16px' }} />

          <div style={s.altLinks}>
            <Link to="/registerform" style={s.altLink}>Sign Up</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ── Styles ────────────────────────────────────────────────── */
const s = {
  page: {
    minHeight:            '100vh',
    display:              'grid',
    gridTemplateColumns:  '1fr 1fr',
    fontFamily:           "'Inter','Segoe UI',sans-serif",
  },

  /* Left */
  leftPanel: {
    background:     'linear-gradient(160deg, #0D9488 0%, #0EA5E9 35%, #2563EB 70%, #1D4ED8 100%)',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    padding:        '60px 8%',
  },
  leftInner:   { maxWidth: 420 },
  logo:        { height: 48, marginBottom: 40, filter: 'brightness(0) invert(1)' },
  leftHeading: { fontSize: 'clamp(28px,3.5vw,44px)', fontWeight: 800, color: '#FFFFFF', letterSpacing: '-0.03em', lineHeight: 1.15, margin: '0 0 18px' },
  leftSub:     { fontSize: 17, color: 'rgba(255,255,255,0.80)', lineHeight: 1.7, marginBottom: 48 },
  statsRow:    { display: 'flex', gap: 32 },
  statItem:    { display: 'flex', flexDirection: 'column', gap: 4 },
  statVal:     { fontSize: 32, fontWeight: 800, color: '#FFFFFF', letterSpacing: '-0.02em' },
  statLabel:   { fontSize: 13, color: 'rgba(255,255,255,0.65)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' },

  /* Right */
  rightPanel: {
    background:     '#F8FAFC',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    padding:        '40px 32px',
  },
  formCard: {
    background:    '#FFFFFF',
    borderRadius:  '16px',
    border:        '1px solid #E2E8F0',
    boxShadow:     '0 4px 24px rgba(0,0,0,0.07)',
    padding:       '40px 40px 32px',
    width:         '100%',
    maxWidth:      '420px',
    position:      'relative',
  },
  close: {
    position: 'absolute', top: 16, right: 20,
    fontSize: 20, color: '#64748B', textDecoration: 'none', lineHeight: 1,
  },
  formHeading: { fontSize: 26, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em', margin: '0 0 8px' },
  formSub:     { fontSize: 14, color: '#64748B', marginBottom: 32 },

  form:  { display: 'flex', flexDirection: 'column', gap: 18 },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 13, fontWeight: 700, color: '#334155' },

  inputWrap: {
    display:      'flex',
    alignItems:   'center',
    border:       '1.5px solid #CBD5E1',
    borderRadius: '8px',
    overflow:     'hidden',
    transition:   'border-color 0.2s',
    background:   '#FFFFFF',
  },
  inputIcon: { width: 18, height: 18, marginLeft: 14, flexShrink: 0 },
  input: {
    flex:       1,
    padding:    '13px 14px',
    border:     'none',
    outline:    'none',
    fontSize:   '15px',
    color:      '#1E293B',
    background: 'transparent',
    width:      '100%',
  },
  eyeBtn: {
    background: 'none', border: 'none', cursor: 'pointer',
    padding:    '0 14px', display: 'flex', alignItems: 'center',
  },

  btn: {
    padding:       '15px',
    background:    '#2563EB',
    color:         '#FFFFFF',
    border:        'none',
    borderRadius:  '8px',
    fontSize:      '15px',
    fontWeight:    700,
    letterSpacing: '0.08em',
    cursor:        'pointer',
    transition:    'background 0.2s',
    width:         '100%',
    marginTop:     4,
  },

  terms:      { fontSize: 12, color: '#94A3B8', textAlign: 'center', margin: '16px 0 0', lineHeight: 1.6 },
  inlineLink: { color: '#2563EB', textDecoration: 'none', fontWeight: 600 },

  divider: {
    margin:     '20px 0 16px',
    display:    'flex',
    alignItems: 'center',
    gap:        12,
  },
  dividerText: {
    fontSize:    12,
    color:       '#94A3B8',
    whiteSpace:  'nowrap',
    flex:        1,
    textAlign:   'center',
    borderTop:   '1px solid #E2E8F0',
    position:    'relative',
    lineHeight:  0,
    padding:     '0 12px',
  },

  altLinks: { display: 'flex', justifyContent: 'center', gap: 16 },
  altLink:  { fontSize: 14, color: '#2563EB', textDecoration: 'none', fontWeight: 700, padding: '10px 32px', border: '1.5px solid #BFDBFE', borderRadius: 50, display: 'inline-block' },
};

export default LoginForm;
